import { render, staticRenderFns } from "./optionItem.vue?vue&type=template&id=5dc606de&scoped=true"
import script from "./optionItem.vue?vue&type=script&lang=js"
export * from "./optionItem.vue?vue&type=script&lang=js"
import style0 from "./optionItem.vue?vue&type=style&index=0&id=5dc606de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc606de",
  null
  
)

export default component.exports